import Vue from 'vue'
import VueRouter from 'vue-router'
import Autocom from '../components/Autocom.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Autocom',
    component: Autocom
  },
  {
    path: '/formulario',
    name: 'Formulario',
    component: () => import(/* webpackChunkName: "Formulario" */ '../components/Formulario.vue')
  },
  {
    path: '/correo',
    name: 'Correo',
    component: () => import(/* webpackChunkName: "Correo" */ '../components/Correo.vue')
  },
  {
    path: '/formularioCortas',
    name: 'FormularioCortas',
    component: () => import(/* webpackChunkName: "FormularioCortas" */ '../components/FormularioCortas.vue')
  },
  {
    path: '/correoCortas',
    name: 'CorreoCortas',
    component: () => import(/* webpackChunkName: "CorreoCortas" */ '../components/CorreoCortas.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
